import { useMemo } from 'react';
import { loadDefaultJapaneseParser } from 'budoux';

const parser = loadDefaultJapaneseParser();

type Props = {
  text: string;
  className?: string;
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'p';
};

/** BudouX phrase wrapping for natural Japanese line breaks. */
export function JaPhrase({ text, className = '', as: Tag = 'span' }: Props) {
  const parts = useMemo(() => parser.parse(text), [text]);
  return (
    <Tag className={`ja-phrase ${className}`.trim()}>
      {parts.map((part, i) => (
        <span key={`${i}-${part.slice(0, 8)}`} className="ja-phrase-unit">
          {part}
        </span>
      ))}
    </Tag>
  );
}
